import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['down', 'group', 'item', 'order', 'up'];

  connect() {
    this.observer = new MutationObserver(() => this.#refresh());

    this.observer.observe(this.element, { attributeFilter: ['style'], attributes: true, childList: true, subtree: true });

    this.#refresh();
  }

  disconnect() {
    this.observer.disconnect();
  }

  down({ currentTarget }) {
    const items = this.#visibleItems();
    const item = currentTarget.closest('[data-nested-move-target="item"]');
    const next = items[items.indexOf(item) + 1];

    if (next) next.after(item);
  }

  up({ currentTarget }) {
    const items = this.#visibleItems();
    const item = currentTarget.closest('[data-nested-move-target="item"]');
    const previous = items[items.indexOf(item) - 1];

    if (previous) previous.before(item);
  }

  #refresh() {
    const items = this.#visibleItems();

    items.forEach((item, index) => {
      this.#within(item, this.orderTargets).value = index;
      this.#within(item, this.groupTargets).classList.toggle('hidden', items.length <= 1);
      this.#within(item, this.upTargets).classList.toggle('move--empty', index === 0);
      this.#within(item, this.downTargets).classList.toggle('move--empty', index === items.length - 1);
    });
  }

  #visibleItems() {
    return this.itemTargets.filter((item) => item.style.display !== 'none');
  }

  #within(item, targets) {
    return targets.find((target) => item.contains(target));
  }
}
